/* eslint-disable jsx-a11y/label-has-associated-control , react/no-unescaped-entities */
import React, { useState, useEffect, useMemo } from 'react'
import { ClickAwayListener } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Button from 'components_newui/button/View'
import NxtCircularLoader from 'components/nxt_circular_loader/View'

const useStyles = makeStyles((theme) => ({
  faded_out: {
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 100,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '6px',
    width: '560px',
    maxWidth: '90vw',
    padding: '32px 48px',
    fontFamily: 'VodafoneRg-Regular',
    color: '#333333',
    maxHeight: '80vh',
    overflowY: 'auto',
  },
  title: {
    fontSize: '28px',
    fontFamily: 'VodafoneRg-Bold',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '16px',
    margin: '8px 0 24px',
    color: '#666',
  },
  selectBox: {
    width: '100%',
    padding: '14px',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginBottom: '16px',
    appearance: 'auto',
    '&:focus': {
      borderColor: '#e60000',
      outline: 'none',
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '24px',
  },
  cancelBtn: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '14px',
    color: '#333',
    background: '#f2f2f2',
    border: '1px solid #ccc',
    borderRadius: '20px',
    padding: '10px 24px',
    cursor: 'pointer',
    '&:hover': {
      background: '#e0e0e0',
    },
  },
  addBtn: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '14px',
    color: '#FFFFFF',
    background: '#e60000',
    border: '1px solid #e60000',
    borderRadius: '20px',
    padding: '10px 24px',
    cursor: 'pointer',
    '&:hover': {
      background: '#cc0000',
    },
    '&:disabled': {
      background: '#ccc',
      border: '1px solid #ccc',
      cursor: 'not-allowed',
    },
  },
  successMessage: {
    color: '#28a745',
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '14px',
    marginTop: '12px',
    textAlign: 'center',
  },
  errorMessage: {
    color: '#e60000',
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '14px',
    marginTop: '12px',
    textAlign: 'center',
  },
  emptyState: {
    textAlign: 'center',
    padding: '24px 0',
    color: '#666',
    fontSize: '16px',
  },
}))


const AddTeamMemberModal = ({
  isOpen,
  onClose,
  userEmail,
  userName,
  myIdeasList = [],
  myIdeasLoading = false,
  addTeamMemberLoading = false,
  inviteTeamMemberLoading = false,
  onAddTeamMember,
  onInviteTeamMember,
  // getMyIdeasFn,
  isAdmin,
}) => {
  const classes = useStyles()
  const [selectedIdeaKey, setSelectedIdeaKey] = useState('')
  const [statusMessage, setStatusMessage] = useState({ type: '', text: '' })
  const [isSuccess, setIsSuccess] = useState(false)

  const ideasData = myIdeasList?.data || myIdeasList || []

  useEffect(() => {
    // if (isOpen && getMyIdeasFn) {
    //   getMyIdeasFn()
    // }
    // Reset state when modal opens
    setSelectedIdeaKey('')
    setStatusMessage({ type: '', text: '' })
    setIsSuccess(false)
  }, [isOpen])

  if (!isOpen) return null




  const handleAddMember = () => {
    if (!selectedIdeaKey || !userEmail) return

    onAddTeamMember(
      { ideaIdKey: selectedIdeaKey, userEmail },
      () => {
        setIsSuccess(true)
        setStatusMessage({ type: 'success', text: `${userName || userEmail} has been added to the idea team successfully!` })
        setSelectedIdeaKey('')
        // Auto-close popup after 2 seconds
        setTimeout(() => {
          onClose()
        }, 2000)
      },
      () => {
        setStatusMessage({ type: 'error', text: 'Failed to add team member. Please try again.' })
      }
    )
  }


  const handleInviteMember = () => {
    if (!selectedIdeaKey || !userEmail) return

    onInviteTeamMember(
      { ideaIdKey: selectedIdeaKey, userEmail },
      () => {
        setIsSuccess(true)
        setStatusMessage({ type: 'success', text: `${userName || userEmail} has been invited to the idea team successfully!` })
        setSelectedIdeaKey('')
        // Auto-close popup after 2 seconds
        setTimeout(() => {
          onClose()
        }, 2000)
      },
      () => {
        setStatusMessage({ type: 'error', text: 'Failed to invite team member. Please try again.' })
      }
    )
  }

  return (
    <div className={classes.faded_out}>
      <ClickAwayListener onClickAway={onClose}>
        <div className={classes.modalContainer}>
          {isSuccess ? (
            /* ===== Success View ===== */
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
              <div className={classes.title} style={{ fontFamily: 'VodafoneRg-Regular',marginBottom:'1rem',color: '#28a745' }}>Team Member Added</div>
              <div className={classes.successMessage} style={{ fontWeight:'bold',fontSize: '16px',fontFamily: 'VodafoneRg-Regular',  marginTop: '16px' }}>
                {statusMessage.text}
              </div>
              <div style={{ marginTop: '24px' }}>
                <button type='button' className={classes.cancelBtn} onClick={onClose}>
                  Close
                </button>
              </div>
            </div>
          ) : (
            /* ===== Form View ===== */
            <>
              <div className={classes.title}>Add to Idea Team</div>
              <div className={classes.subtitle} style={{margin:'1rem 0'}}>
                Add <strong style={{ fontFamily: 'VodafoneRg-Bold'}}>{userName || userEmail}</strong>  as a team member to one of your ideas.
              </div>

              <NxtCircularLoader isLoading={myIdeasLoading}>
                {ideasData.length === 0 ? (
                  <div className={classes.emptyState} style={{ fontFamily: 'VodafoneRg-Bold',fontSize:'1.125rem' }} >
                    You don't own any ideas yet. Create an idea first to add team members.
                  </div>

                ) : (
                  // jsx-a11y/label-has-associated-control

                    <label
                      style={{
                        fontFamily: 'VodafoneRg-Bold',
                        fontSize: '14px',
                        display: 'block',
                        marginBottom: '8px',
                      }}
                      >
                      Select an Idea
                      <select
                        id="choose_list_idea"
                        className={classes.selectBox}
                        value={selectedIdeaKey}
                        onChange={(e) => {
                          setSelectedIdeaKey(e.target.value)
                          setStatusMessage({ type: '', text: '' })
                        }}
                      >
                        <option value="">Choose an idea</option>
                        {ideasData.filter((idea) => idea.status !== "DRAFT" && idea.status !== "DELETED").map((idea) => (
                          <option key={idea.id || idea.key} value={idea.id || idea.key}>
                            {idea.title || idea.name || `Idea ${idea.id || idea.key}`}
                          </option>
                        ))}
                      </select>
                    </label>
                )}
              </NxtCircularLoader>

              {statusMessage.text && statusMessage.type === 'error' && (
                <div className={classes.errorMessage}>
                  {statusMessage.text}
                </div>
              )}

              <div className={classes.buttonRow}>
                <button type='button' className={classes.cancelBtn} onClick={onClose}>
                  Cancel
                </button>
                {ideasData.length > 0 && (
                  <> { isAdmin ? (
                  <button
                    type='button'
                    className={classes.addBtn}
                    onClick={handleAddMember}
                    disabled={!selectedIdeaKey || addTeamMemberLoading}
                  >
                    {addTeamMemberLoading ? 'Adding...' : 'Add Team Member'}
                  </button>)
                  :null}
                  <button
                    type='button'
                    className={classes.addBtn}
                    onClick={handleInviteMember}
                    disabled={!selectedIdeaKey || inviteTeamMemberLoading}
                  >
                    {inviteTeamMemberLoading ? 'Inviting...' : 'Invite Team Member'}
                  </button>
                </>)}
              </div>
            </>
          )}
        </div>
      </ClickAwayListener>
    </div>
  )
}

export default AddTeamMemberModal

